import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../../context/authContext";
import AuthService from "../../services/resource/authService";
import UsuarioService from "../../services/resource/usuarioService";
import LOGO from '../../assets/logo.png'
import Button from "../../componentes/button/button";
import Input from "../../componentes/input/input";
import { aplicativosPermitidosDoUsuario, ultimoAplicativoValido } from "../../config/applications";

function Login() {
  const navigate = useNavigate();
  const auth = useAuth();
  const service = new UsuarioService();

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    document.title = "MyDash | Distribuidora York";

    localStorage.clear();
  }, []);

  const login = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    service.autenticar({ email, senha })
      .then((response) => {
        auth.login(response.data, response.data.token, response.data.refreshToken);

        if (response.data.alteraSenhaLogin === true) {
          navigate("/alterar-senha");
          return;
        }

        // Decodifica o token recém-salvo pra saber a quais aplicativos esse usuário tem acesso
        // (claim "aplicativos") e decidir pra onde ir: direto, se só houver um permitido ou uma
        // escolha anterior ainda válida; senão, pergunta na tela de seleção.
        const usuarioLogado = AuthService.getUser();
        const permitidos = aplicativosPermitidosDoUsuario(usuarioLogado);

        if (permitidos.length === 1) {
          navigate(permitidos[0].rotaInicial);
          return;
        }

        const chaveValida = ultimoAplicativoValido(permitidos);
        const appEscolhido = permitidos.find(app => app.key === chaveValida);
        navigate(appEscolhido ? appEscolhido.rotaInicial : "/selecionar-aplicativo");
      })
      .catch((err) => {
        setTimeout(() => setError(err.response?.data?.message || "Credenciais inválidas. Verifique e tente novamente."), 400);
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 400);
      });
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background z-50 px-4">
      <div className="w-full max-w-md bg-card rounded-2xl border border-border p-8 flex flex-col shadow-pop">

        {/* Logo */}
        <div className="flex flex-col items-center mb-7">
          <img src={LOGO} alt="Logo Distribuidora York" className="h-12 w-auto object-contain mb-3" />
          <p className="text-xs text-muted-foreground">Acesse sua conta</p>
        </div>

        <form onSubmit={login} className="flex flex-col gap-4">

          {/* E-mail */}
          <div className="flex flex-col gap-1.5">
            <label htmlFor="email" className="text-xs font-medium text-muted-foreground">
              E-mail, CPF ou usuário
            </label>
            <div className="relative">
              <i className="fa fa-envelope absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground text-sm pointer-events-none" />
              <input
                id="email"
                type="text"
                autoComplete="email"
                 placeholder="Digite seu e-mail, CPF ou usuário"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="auth-input pl-9 pr-3"
              />
            </div>
          </div>

          {/* Senha */}
          <div className="flex flex-col gap-1.5">
            <label htmlFor="senha" className="text-xs font-medium text-muted-foreground">
              Senha
            </label>
            <div className="relative">
              <i className="fa fa-lock absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground text-sm pointer-events-none" />
              <input
                id="senha"
                type={showPass ? "text" : "password"}
                autoComplete="current-password"
                placeholder="••••••••"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                className="auth-input pl-9 pr-10"
              />
              <button
                type="button"
                aria-label={showPass ? "Ocultar senha" : "Mostrar senha"}
                onClick={() => setShowPass((v) => !v)}
                className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors duration-150 p-1"
              >
                <i className={`fa ${showPass ? "fa-eye-slash" : "fa-eye"} text-sm`} />
              </button>
            </div>
          </div>

          {/* Link esqueceu */}
          <div className="flex justify-end -mt-1">
            <a
              href="/solicitar-senha"
              className="text-xs text-muted-foreground hover:text-primary transition-colors duration-150"
            >
              Esqueceu sua senha?
            </a>
          </div>

          {/* Mensagem de erro */}
          {error && (
            <div className="flex items-start gap-2.5 px-3 py-2.5 rounded-lg bg-destructive/5 border border-destructive/20">
              <i className="fa fa-exclamation-circle text-destructive text-sm mt-0.5 flex-shrink-0" />
              <p className="text-xs text-destructive leading-snug">{error}</p>
            </div>
          )}

          {/* Botão entrar */}
          <button
            type="submit"
            disabled={loading}
            className="mt-1 w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg bg-primary hover:brightness-95 text-primary-foreground text-sm font-medium shadow-xs transition-all duration-150 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading
              ? <><i className="fa fa-spinner fa-spin text-sm" />Entrando...</>
              : <><i className="fa fa-sign-in-alt text-sm" />Entrar</>
            }
          </button>

        </form>

        <p className="text-center text-xs text-muted-foreground/70 mt-6">
          © 2026 Mydash
        </p>
      </div>
    </div>
  );
}

export default Login;